// notification Event management
import axios from "axios";
import { API_GET_NOTIFICATION, API_GET_SHIP_TYPE } from "@/constants/api";
const state = {
  dataEvent: [],
  loading: false,
  shipTypes: []
};

const getters = {
  dataEvent: state => state.dataEvent,
  loading: state => state.loading,
  error: state => state.error
};

const actions = {
  getNotificationEvent(context, payload) {
    const { params, headers } = payload;
    context.commit("LOADING_NOTIFICATION_EVENT", { loading: true });
    const url = API_GET_NOTIFICATION();
    axios
      .get(url, {
        params,
        headers
      })
      .then(response => {
        context.commit("SUCCESS_NOTIFICATION_EVENT", response);
      })
      .catch(error => {
        context.commit("ERROR_NOTIFICATION_EVENT", { error });
      })
      .finally(() => {
        context.commit("LOADING_NOTIFICATION_EVENT", { loading: false });
      });
  },
  getNotificationEventWithParams(context, payload) {
    const { headers, params } = payload;
    context.commit("LOADING_NOTIFICATION_EVENT", { loading: true });
    const url = API_GET_NOTIFICATION();
    axios
      .get(url, {
        params,
        headers
      })
      .then(response => {
        context.commit("SUCCESS_NOTIFICATION_EVENT", response);
      })
      .catch(error => {
        context.commit("ERROR_NOTIFICATION_EVENT", { error });
      })
      .finally(() => {
        context.commit("LOADING_NOTIFICATION_EVENT", { loading: false });
      });
  },
  getShipTypesNotify(context, payload) {
    const { headers } = payload;
    const url = API_GET_SHIP_TYPE();
    axios
      .get(url, {
        params: {
          limit: 100
        },
        headers
      })
      .then(response => {
        this.shipTypes = response.data;
        context.commit("SUCCESS_NOTIFICATION_SHIP_TYPE", response);
      })
      .catch(error => {
        context.commit("ERROR_NOTIFICATION_EVENT", { error });
      });
  }
};

const mutations = {
  LOADING_NOTIFICATION_EVENT(state, payload) {
    state.loading = payload.loading;
  },
  SUCCESS_NOTIFICATION_EVENT(state, payload) {
    state.dataEvent = payload.data;
  },
  ERROR_NOTIFICATION_EVENT(state, payload) {
    state.error = payload.error;
  },
  SUCCESS_NOTIFICATION_SHIP_TYPE(state, payload) {
    state.shipTypes = payload.data;
  },
  ERROR_NOTIFICATION_SHIP_TYPE(state, payload) {
    state.error = payload.error;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
